import ProductFullBleedHero from './ProductFullBleedHero';

export default ProductFullBleedHero;
